import styled from 'styled-components';
import Button from 'components/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  max-width: 512px;
  height: 230px;
  border-radius: 12px;
  padding: 20px 20px 32px 20px;
  margin-top: 50px;
  background-color: #fafafa;
`; 

export const StyledButton = styled(Button)`
  max-width: 300px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  margin-top: auto;
  justify-content: center;
  width: 100%;
`;

export const Title = styled.h4`
  margin-bottom: 20px;
  font-weight: 600;
  color: #ff441f;
`;

export const Subtitle = styled.p`
  color: #626e75;
`;
